<svg
    width="233"
    height="140"
    viewBox="0 0 233 140"
    xmlns="http://www.w3.org/2000/svg">
    <svg:path
        class="outer-roof"
        d="M115.834 138.468L0.973073 69.4513L116.128 0.699041L231.27 69.4502L115.834 138.468Z" />

    <!-- Roof -->
    <svg:path
        d="M116.129 9.05322L14.7101 69.6153L116.129 130.419L217.561 69.6153L116.129 9.05322Z"
        [attr.fill]="'var(--roof-bg)'" />

    <g
        [x]="40"
        [y]="-35"
        app-roof-box></g>

    <g
        [x]="-5"
        y="-5"
        app-roof-box></g>
</svg>